<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-moeda') {
            next({ name: 'ven-moeda-list' })
        } else if (to.name == 'des-moeda') {
            next({ name: 'des-moeda-list', replace: true })
        } else {
            next()
        }
    },
    created() {
        if (this.$route.name == 'ven-moeda') {
            this.$router.push({ name: 'ven-moeda-list' })
        } else if (this.$route.name == 'des-moeda') {
            this.$router.replace({ name: 'des-moeda-list' })
        }
    }
}
</script>